import React from 'react';
import NetworkCard from './NetworkCard';

const UserCard = (props) => {
  const {user, connection, following, manageNetwork} = props
  return <NetworkCard user={user} isSearchResult connection={connection} following={following} manageNetwork />;
};

export default UserCard;
